import React from 'react';
import { MotionConfig } from 'framer-motion';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AutoGallery } from './components/AutoGallery';
import { Motivations } from './components/Motivations';
import { HowItWorks } from './components/HowItWorks';
import { CreationsGallery } from './components/CreationsGallery';
import { MainGuide } from './components/MainGuide';
import { Bonuses } from './components/Bonuses';
import { TemplateLibrary } from './components/TemplateLibrary';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { tricotinGallery } from './data/galleries';
import { siteConfig } from './data/siteConfig';
import { useMetaPixel } from './hooks/useMetaPixel';
import { useDocumentMeta } from './hooks/useDocumentMeta';
type AppProps = {
  /** Vista di lavoro: mostra i contenuti da confermare con etichette. Disattivare prima di pubblicare. */
  draftPreview?: boolean;
};
export function App({
  draftPreview = true
}: AppProps) {
  useMetaPixel(siteConfig.metaPixelId);
  useDocumentMeta(siteConfig.pageTitle, siteConfig.pageDescription, 'it');
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="4n7g6m8exco">
      <div className="min-h-screen w-full [overflow-x:clip] bg-cream font-sans text-ink selection:bg-berry-deep selection:text-white" data-id="element-1" data-mp="2zl39tfhhuw2o">
        <AnnouncementBar data-id="element-2" data-mp="33lx0ggmbmoz9" />
        <Header data-id="element-3" data-mp="33n6xr3lcnt4u" />
        <main id="contenuto" data-id="element-4" data-mp="33orjq4tlm3r3">
          <Hero draftPreview={draftPreview} data-id="element-5" data-mp="38m1fe27kzbnd" />
          <AutoGallery items={tricotinGallery} label="Esempi di creazioni in tricotin" data-id="element-6" data-mp="38k6uup081ljt" />
          <Motivations data-id="element-7" data-mp="3dlnukh6yz1yt" />
          <HowItWorks data-id="element-8" data-mp="3dm5vvs8ho6dl" />
          <CreationsGallery data-id="element-9" data-mp="nvj2rdpwcaoo" />
          <MainGuide data-id="element-10" data-mp="nwc0jp6vnpuo" />
          <Bonuses data-id="element-11" data-mp="nuraabrlit2m" />
          <TemplateLibrary data-id="element-12" data-mp="nxn69ujvv7of" />
          <Testimonials draftPreview={draftPreview} data-id="element-13" data-mp="sudl6ejybx89" />
          <AutoGallery items={tricotinGallery} label="Altre idee di creazioni in tricotin" data-id="element-14" data-mp="st2i6gybyti7" />
          <Offer data-id="element-15" data-mp="34x1vh8db93d" />
          <FAQ data-id="element-16" data-mp="38kwyktgo3k7" />
        </main>
        <Footer data-id="element-17" data-mp="3ud1glcmeruc7" />
      </div>
    </MotionConfig>;
}